import Icon from 'components/atoms/Icon';
import Loader from 'components/molecules/Loader';

function FileProcessingIndicator() {
  return (
    <div className="text-gray-700">
      <div className="flex items-center">
        File uploaded: <Icon className="p-1" name="check-circle" size={16} svgFillClassName="text-green" />
      </div>
      <div>
        <Loader color="green" type="small" />
        <span className="mr-1">Processing file... Please wait.</span>
      </div>
    </div>
  );
}

export default FileProcessingIndicator;
